module.exports = __webpack_public_path__ + "static/media/cardOrder.ef0e5100.svg";